const Plus = ({ width }) => {
    return (
        <div className={`plus-icon ${width}`}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                enableBackground="new 0 0 100 100"
                version="1.1"
                viewBox="0 0 100 100"
                xmlSpace="preserve"
            >
                <path d="M46.4 0.1H53.4V100.1H46.4z" className="st0"></path>
                <path d="M-0.1 46.6H99.9V53.6H-0.1z" className="st0"></path>
            </svg>
        </div>
    )
}

export default Plus
